module.exports = __webpack_public_path__ + "img/index09.b2cdcc56.jpg";